import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { pruned, timelineSearchSchema, type TimelineSearch } from '@/components/Ams/search'
import { TimelinePage } from '@/components/Ams/TimelinePage'
import { inPageSearch } from '@/lib/searchNavigation'

/** Wiring only. */
export const Route = createFileRoute('/_app/marketing/ams/history/target/$targetId')({
  validateSearch: timelineSearchSchema,
  component: TargetIdRoute,
})

function TargetIdRoute() {
  const { targetId } = Route.useParams()
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <TimelinePage
      level="target"
      entityId={targetId}
      store={search.store}
      adGroup={search.adGroup}
      adType={search.adType}
      display={search}
      onDisplayChange={(next) => void navigate(inPageSearch<TimelineSearch>(pruned, next))}
    />
  )
}
